import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';

import FormBase from 'components/forms/new/FormBase';
import DialPlanNameField from './formFields/DialPlanNameField';
import { useAddDialPlan } from './queries';
import { dialPlanSchema } from './schema';
import { formContainerStyles } from './constants';
import useFieldValidation from 'hooks/useFieldValidation';
import { Alert, AlertIcon, AlertDescription } from 'components/v4';

const DialPlanAdd = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { darkMode } = useSelector((state) => state.settings);
    const { mutate: addDialPlan, isLoading } = useAddDialPlan();
    const [error, setError] = useState(null);
    const [modalState, setModalState] = useState({ name: '' });

    const breadCrumbTrail = [
        { label: 'Dial Plans', path: '/dial-plans' },
        {
            label: 'Add Dial Plan',
            path: `/dial-plans/add${location.search}`,
        },
    ];

    const { validatefn } = useFieldValidation(modalState, dialPlanSchema);

    const handleSubmit = (values, actions) => {
        if (!validatefn()) {
            actions.setSubmitting(false);
            return;
        }

        setError(null);
        addDialPlan(values, {
            onSuccess: (data) => {
                navigate(`/dial-plans/${data.id}${location.search}`);
            },
            onError: (err) => {
                setError(err?.response?.data?.message || 'An error occurred.');
                actions.setSubmitting(false);
            },
        });
    };

    return (
        <Box
            sx={formContainerStyles.noHorizontalDivider}
            aria-label="Add Dial Plan Page Form Container">
            <FormBase
                breadCrumbTrail={breadCrumbTrail}
                initialValues={{ name: '' }}
                finalFormSubmit={handleSubmit}
                backLink={`/dial-plans${location.search}`}
                isLoading={isLoading}>
                {(formProps) => {
                    const { errors, touched, handleChange } = formProps;
                    return [
                        <DialPlanNameField
                            key="name"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                            onChange={(e) => {
                                handleChange(e);
                                setModalState((prev) => ({
                                    ...prev,
                                    name: e.target.value,
                                }));
                            }}
                        />,
                        error && (
                            <Box key="error-box" paddingBottom="0.5rem">
                                <Alert
                                    status="error"
                                    mt={4}
                                    marginBottom="1rem">
                                    <AlertIcon />
                                    <AlertDescription>{error}</AlertDescription>
                                </Alert>
                            </Box>
                        ),
                    ];
                }}
            </FormBase>
        </Box>
    );
};

export default DialPlanAdd;
